import type { OAuthAccessToken } from '~/elc/features/integrations/types';
import { Stack } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { EmptyTableState } from '~/features/common';
import { IntegrationContainer } from '~/features/integrations/styles';
import { IntegrationHeader } from '~/features/integrations/components/IntegrationHeader';
import { OAuth2Icon } from '~/features/integrations/icons';
import { OAuthConnectionCard } from '~/features/integrations/components/OAuthConnectionCard';

const PAGE_DESCRIPTION = I18n.t('js.admin.integration_settings.oauth_connections.page_description');
const PAGE_TITLE = I18n.t('js.admin.integration_settings.oauth_connections.page_title');
const TABLE_EMPTY_HEADING = I18n.t('js.admin.integration_settings.oauth_connections.table_empty_heading');

interface OAuthConnectionsPageProps {
  integrationBaseUrl: string;
  oauthConnections: OAuthAccessToken[];
  onRevoke: (id: number, callbackFn?: () => void) => void;
}

export const OAuthConnectionsPageContent = ({
  integrationBaseUrl,
  oauthConnections,
  onRevoke,
}: OAuthConnectionsPageProps) => (
  <IntegrationContainer>
    <IntegrationHeader
      baseUrl={integrationBaseUrl}
      icon={<OAuth2Icon />}
      name={PAGE_TITLE}
      description={PAGE_DESCRIPTION}
    />
    {oauthConnections.length > 0 ? (
      <Stack size={6}>
        {oauthConnections.map((connection) => (
          <OAuthConnectionCard
            key={connection.id}
            applicationName={connection.applicationName}
            id={connection.id}
            scopes={connection.scopes}
            createdAt={connection.createdAt}
            expiresAt={connection.expiresAt}
            revokedAt={connection.revokedAt}
            onRevoke={onRevoke}
          />
        ))}
      </Stack>
    ) : (
      <EmptyTableState heading={TABLE_EMPTY_HEADING} />
    )}
  </IntegrationContainer>
);
